import React from 'react'
import { Dropdown, Menu } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import * as DROPDOWN from 'constant/dropdown'
import PropTypes from 'prop-types'
import NewTag from 'view/page/tag-management/component/new-tag'
import styles from 'view/page/category-management/component/table/component/action/styles'

const Action = ({ site }) =>
  (<span>
    <Dropdown
      overlay={
        <Menu>
          <Menu.Item>
            <NewTag site={site} />
          </Menu.Item>
        </Menu>
      }
      overlayStyle={{ zIndex: 1 }}
      trigger={[DROPDOWN.TRIGGER]}
    >
      <div className={styles.show_more}>
        <span>More</span>
        <DownOutlined />
      </div>
    </Dropdown>
  </span>)

Action.propTypes = {
  site: PropTypes.object,
  tag: PropTypes.object
}

export default Action
